import React from "react";
import FeatureCard from "./FeatureCard";
import { faCalculator } from "@fortawesome/free-solid-svg-icons";
import { faHeadset } from "@fortawesome/free-solid-svg-icons";
import { faMobileScreenButton } from "@fortawesome/free-solid-svg-icons";
import { faPersonCircleCheck } from "@fortawesome/free-solid-svg-icons";
import { faBell } from "@fortawesome/free-solid-svg-icons";
import { faDatabase } from "@fortawesome/free-solid-svg-icons";
import { faScrewdriverWrench } from "@fortawesome/free-solid-svg-icons";
import { faFileContract } from "@fortawesome/free-solid-svg-icons";
import "../Cards.css";

function FeatureCardCMTest() {
  return (
    <div className="cards">
      <div className="cards__container">
        <div className="feature-cards__wrapper">
          <ul className="feature-card__item">
            <FeatureCard
              iconName={faPersonCircleCheck}
              // Гибкая интеграция
              // Возможность частичной или полной интеграции с вашими текущими сервисами, обеспечивая максимальную совместимость и удобство.
              header="Flexible Integration"
              text="Possibility of partial or full integration with your current services, ensuring maximum compatibility and convenience."
            />
            <FeatureCard
              iconName={faCalculator}
              // Калькулятор смесей
              // Уникальный инструмент для быстрого и удобного подбора рецептуры, обеспечивающий точную настройку плотности.
              header="Mixture Calculator"
              text="A unique tool for quick and convenient formulation selection, ensuring precise density adjustment."
            />
            <FeatureCard
              iconName={faDatabase}
              // Перенос базы данных
              // Полный перенос вашей текущей базы данных, гарантирующий беспроблемный переход к новым возможностям приложения.
              header="Database Migration"
              text="Complete migration of your current database, ensuring a seamless transition to the application's new capabilities."
            />
            <FeatureCard
              iconName={faFileContract}
              // Электронный паспорт
              // Возможность хранить всю необходимую документацию электронно, обеспечивая надежное и структурированное хранение информации.
              header="Electronic Passport"
              text="Ability to store all necessary documentation electronically, ensuring reliable and structured information storage."
            />
          </ul>
          <ul className="feature-card__item">
            <FeatureCard
              iconName={faScrewdriverWrench}
              // Шаблоны
              // Создание готовых наборов тестов для моментального ускорения работы лаборатории и инженерного состава.
              header="Templates"
              text="Creation of ready-made test sets for instant acceleration of laboratory and engineering team work."
            />
            <FeatureCard
              iconName={faMobileScreenButton}
              // Понятный интерфейс
              // Интуитивно понятный интерфейс, который делает процесс работы с приложением максимально комфортным и эффективным.
              header="User-Friendly Interface"
              text="Intuitive interface that makes working with the application as comfortable and efficient as possible."
            />
            <FeatureCard
              iconName={faBell}
              // Система уведомлений
              // Удобная и гибкая система уведомлений, позволяющая быть в курсе всех событий вашей лаборатории в режиме реального времени.
              header="Notification System"
              text="Convenient and flexible notification system allowing you to stay informed about all events in your laboratory in real time."
            />
            <FeatureCard
              iconName={faHeadset}
              // Техническая поддержка
              // Постоянно обновляющаяся техническая поддержка, гарантирующая бесперебойную работу вашей лаборатории.
              header="Technical Support"
              text="Continuously updated technical support, ensuring uninterrupted operation of your laboratory."
            />
          </ul>

          <ul className="feature-card__item__mobile">
            <FeatureCard
              iconName={faPersonCircleCheck}
              // Гибкая интеграция
              // Возможность частичной или полной интеграции с вашими текущими сервисами, обеспечивая максимальную совместимость и удобство.
              header="Flexible Integration"
              text="Possibility of partial or full integration with your current services, ensuring maximum compatibility and convenience."
            />
            <FeatureCard
              iconName={faCalculator}
              // Калькулятор смесей
              // Уникальный инструмент для быстрого и удобного подбора рецептуры, обеспечивающий точную настройку плотности.
              header="Mixture Calculator"
              text="A unique tool for quick and convenient formulation selection, ensuring precise density adjustment."
            />
          </ul>
          <ul className="feature-card__item__mobile">
            <FeatureCard
              iconName={faDatabase}
              // Перенос базы данных
              // Полный перенос вашей текущей базы данных, гарантирующий беспроблемный переход к новым возможностям приложения.
              header="Database Migration"
              text="Complete migration of your current database, ensuring a seamless transition to the application's new capabilities."
            />
            <FeatureCard
              iconName={faFileContract}
              // Электронный паспорт
              // Возможность хранить всю необходимую документацию электронно, обеспечивая надежное и структурированное хранение информации.
              header="Electronic Passport"
              text="Ability to store all necessary documentation electronically, ensuring reliable and structured information storage."
            />
          </ul>
          <ul className="feature-card__item__mobile">
            <FeatureCard
              iconName={faScrewdriverWrench}
              // Шаблоны
              // Создание готовых наборов тестов для моментального ускорения работы лаборатории и инженерного состава.
              header="Templates"
              text="Creation of ready-made test sets for instant acceleration of laboratory and engineering team work."
            />
            <FeatureCard
              iconName={faMobileScreenButton}
              // Понятный интерфейс
              // Интуитивно понятный интерфейс, который делает процесс работы с приложением максимально комфортным и эффективным.
              header="User-Friendly Interface"
              text="Intuitive interface that makes working with the application as comfortable and efficient as possible."
            />
          </ul>
          <ul className="feature-card__item__mobile">
            <FeatureCard
              iconName={faBell}
              // Система уведомлений
              // Удобная и гибкая система уведомлений, позволяющая быть в курсе всех событий вашей лаборатории в режиме реального времени.
              header="Notification System"
              text="Convenient and flexible notification system allowing you to stay informed about all events in your laboratory in real time."
            />
            <FeatureCard
              iconName={faHeadset}
              // Техническая поддержка
              // Постоянно обновляющаяся техническая поддержка, гарантирующая бесперебойную работу вашей лаборатории.
              header="Technical Support"
              text="Continuously updated technical support, ensuring uninterrupted operation of your laboratory."
            />
          </ul>
        </div>
      </div>
    </div>
  );
}

export default FeatureCardCMTest;
